import { Question } from "./QuestionTypes"
import { questions as d20200704 } from "./2020-07-04"
import { questions as d20201027 } from "./2020-10-27"
import { questions as d20211021 } from "./2021-10-21"
import { questions as d20211118 } from "./2021-11-18"
import { questions as d20220106 } from "./2022-01-06"
import { questions as d20220303 } from "./2022-03-03"
import { questions as d20220608 } from "./2022-06-08"
import { questions as d20220721 } from "./2022-07-21"
import { questions as d20220831 } from "./2022-08-31"
import { questions as d20220929 } from "./2022-09-29"
import { questions as personal } from "./personal"

export type Deck = {
	slug: string
	label: string
	questions: Question[][]
}

const dated = (slug: string, questions: Question[][]): Deck => ({
	slug,
	label: new Date(`${slug}T12:00:00`).toLocaleDateString("en-CA", {
		year: "numeric",
		month: "long",
		day: "numeric",
	}),
	questions,
})

export const decks: Deck[] = [
	dated("2022-09-29", d20220929),
	dated("2022-08-31", d20220831),
	dated("2022-07-21", d20220721),
	dated("2022-06-08", d20220608),
	dated("2022-03-03", d20220303),
	dated("2022-01-06", d20220106),
	dated("2021-11-18", d20211118),
	dated("2021-10-21", d20211021),
	dated("2020-10-27", d20201027),
	dated("2020-07-04", d20200704),
	{ slug: "personal", label: "Personal round", questions: personal },
]

export const deckMap: Record<string, Deck> = Object.fromEntries(decks.map(d => [d.slug, d]))

export const countQuestions = (d: Deck) => d.questions.reduce((n, r) => n + r.length, 0)
